// EVENT: hover/click on UpSell Cart Icon
$(function () {
  const isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return (
        navigator.userAgent.match(/IEMobile/i) ||
        navigator.userAgent.match(/WPDesktop/i)
      );
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  const m = isMobile.any() || false;

  $(document).on(
    "change",
    ".custom-cd-product-item-variants-selection select",
    function (e) {
      e.preventDefault();
      let formData = {
        items: [
          {
            id: e.target.value,
            quantity: 1,
          },
        ],
      };
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          // Update Cart
          fetch(window.Shopify.routes.root + "cart.js", {
            method: "GET",
          })
            .then((response) => {
              // Update Cart
              var cart = response.json();
              updateCartCount(cart.item_count);
              updateCartDrawer();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  );
});
